export const LANDING_PAGE = '/';
export const BUDGET_PAGE = '/budget';
export const TRANSACTION_PAGE = '/transaction';
export const CREATE_BUDGET_PAGE = '/create-budget';
